import React, { useState, useEffect } from "react";
import { Navbar, Nav, NavDropdown, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import Logo from "../assets/Logotipo.svg";
import iso from "../assets/iso.svg";
import { HashLink } from "react-router-hash-link";
import styled from "styled-components";

// FontAwesome
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
library.add(fas);

const Div = styled.div`

/* ==============================
   HEADER
============================== */

.navbar {
    min-height: 76px;
}

.brand-img {
    width: 155px;
}


/* navegación */

.main-nav {
    align-items: center;
}

.main-nav .nav-link,
.main-nav .dropdown-toggle {
    color: #536170 !important;

    font-size: 14px;
    font-weight: 500;

    padding-left: 12px !important;
    padding-right: 12px !important;

    transition: color .2s ease;
}

.main-nav .nav-link:hover,
.main-nav .dropdown-toggle:hover {
    color: #E85A20 !important;
}


/* ==============================
   CONTACTO
============================== */

.header-contact {
    display: flex;
    align-items: center;

    margin-left: 15px;
    padding-left: 15px;

    border-left: 1px solid #e5e8eb;

    gap: 15px;
}

.header-contact a {
    display: flex;
    align-items: center;
    gap: 6px;

    color: #687586;

    font-size: 13px;

    text-decoration: none;

    white-space: nowrap;

    transition: color .2s ease;
}

.header-contact a:hover {
    color: #E85A20;
}

.header-contact svg {
    font-size: 14px;
}


/* WhatsApp */

.contact-whatsapp svg {
    font-size: 17px;
}


/* ==============================
   INGRESO
============================== */

.sign-button {
    display: flex !important;
    align-items: center;
    gap: 7px;

    margin-left: 15px;

    padding: 10px 15px !important;

    background: #E85A20;

    border-radius: 7px;

    color: #ffffff !important;

    font-size: 13px;
    font-weight: 600;

    white-space: nowrap;

    transition: all .2s ease;
}

.sign-button:hover {
    background: #d94f19;

    color: #ffffff !important;

    transform: translateY(-1px);
}

    position: sticky;
    top: 0;
    z-index: 999;

    iso {
        width:100%;
    }


    @media screen and (max-width: 991px) {

    .navbar {
        padding: 10px 15px !important;
    }

    .brand-img {
        width: 50px !important;
    }

    .main-nav {
        margin-top: 15px;
    }

    .header-contact {
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        margin: 15px 0;
        padding: 10px 0;

        border-left: none;
        border-top: 1px solid #e5e8eb;
        border-bottom: 1px solid #e5e8eb;

        gap: 8px;
    }

    .sign-button {
        display: none !important;
    }

    .sign-button-top {
        font-size: 12px;
        padding: 9px 10px;
    }
}



    @media screen and (min-width:996px) {

        .sign-button-top {
            display: none;
        }

        .sign-button {
            color: white !important;
            background: #e94f24;
            border-radius: 10px
        }
    }

    @media screen and (max-width:996px) {

        .brand-img {
            width: 50px !important;
        }

        .sign-button {
            display: none
        }

        .sign-button-top {
            font-size: 12px;
            padding: 10px 10px
        }
    }

}`;

export default function Navigation() {
  const [width, setWidth] = useState(window.innerWidth);

  const innerWidth = () => {
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", innerWidth);
    return () => window.removeEventListener("resize", innerWidth);
  });

  return (
    <Div>
      <Navbar
        collapseOnSelect
        expand="lg"
        bg="light"
        variant="light"
        className="p-3"
      >
        <div className="container-xl">
          <Navbar.Brand as={Link} to="/">
            <img
              className="brand-img"
              src={width < 992 ? iso : Logo}
              width="150px"
              alt=""
            />
          </Navbar.Brand>

          <Button
            variant="light"
            className="sign-button-top btn-company"
            href="http://miseguro.edificarseguros.com.ar/#/login"
            target="_blank"
          >
            <FontAwesomeIcon icon="fa-solid fa-user" /> MI SEGURO
          </Button>

          <Navbar.Toggle aria-controls="responsive-navbar-nav" />

          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="ml-auto main-nav">
              <NavDropdown title="Institucional" id="institutional-dropdown">
                <NavDropdown.Item as={Link} to="/sobre-nosotros">
                  Quiénes somos
                </NavDropdown.Item>

                <NavDropdown.Item as={Link} to="/rrhh">
                  Recursos Humanos
                </NavDropdown.Item>
              </NavDropdown>

              <Nav.Link as={HashLink} to="/#services">
                Servicios
              </Nav.Link>

              <NavDropdown title="Clientes" id="clients-dropdown">
                <NavDropdown.Item as={Link} to="/preguntas-frecuentes">
                  Preguntas frecuentes
                </NavDropdown.Item>

                <NavDropdown.Item as={Link} to="/formularios">
                  Formularios
                </NavDropdown.Item>

                <NavDropdown.Item as={Link} to="/anulacion-poliza">
                  Arrepentimiento de contratación
                </NavDropdown.Item>
              </NavDropdown>

              <Nav.Link as={HashLink} to="/#contactus">
                Contacto
              </Nav.Link>
            </Nav>

            <div className="header-contact">
              <a href="tel:08109993443" className="contact-phone">
                <FontAwesomeIcon icon="phone" />
                <span>0810-999-3343</span>
              </a>

              <a
                href="https://wa.me/541122756141"
                target="_blank"
                rel="noopener noreferrer"
                className="contact-whatsapp"
              >
                <FontAwesomeIcon icon={faWhatsapp} />
                <span>(11) 2275-6141</span>
              </a>
            </div>

            <a
              className="sign-button"
              href="http://miseguro.edificarseguros.com.ar/#/login"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon="fa-solid fa-user" />
              <span> MI SEGURO</span>
            </a>
          </Navbar.Collapse>


          {/* <Navbar.Collapse id="responsive-navbar-nav">
                    <Nav className="ml-auto">
                        <NavDropdown title="Institucional" id="collasible-nav-dropdown">
                            <NavDropdown.Item as={Link} to="/sobre-nosotros">Quienes somos?</NavDropdown.Item>
                            <NavDropdown.Item as={Link} to="/rrhh">Recursos Humanos</NavDropdown.Item>
                        </NavDropdown>
                        <Nav.Link as={HashLink} to="/#services">Servicios</Nav.Link>
                        <NavDropdown title="Clientes" id="collasible-nav-dropdown">
                            <NavDropdown.Item as={Link} to="/preguntas-frecuentes">Preguntas Frecuentes</NavDropdown.Item>
                            <NavDropdown.Item as={Link} to="/formularios">Formularios</NavDropdown.Item>    
                            <NavDropdown.Item as={Link} to="/anulacion-poliza">Arrepentimiento de contratación</NavDropdown.Item>    
                        </NavDropdown>
                            <Nav.Link as={HashLink} to="/#contactus">Contacto</Nav.Link>
                            <Nav.Link as={HashLink} to="/#contactus">
                                <FontAwesomeIcon icon="phone" color="secondary" style={{ height: '14px' }} /> 0810-999-3343
                            </Nav.Link>
                       
                        <Nav.Link href="https://wa.me/541122756141" target="_blank">
                            <FontAwesomeIcon icon={faWhatsapp} color="secondary" style={{ height: '18px' }} /> (11) 2275-6141
                        </Nav.Link>
                        <Nav.Link className="sign-button" href="http://miseguro.edificarseguros.com.ar/#/login" target="_blank"><FontAwesomeIcon icon="sign-in-alt" color="secondary" style={{ height: '14px' }} /> Ingreso a mi Seguro</Nav.Link>
                    </Nav>
                    </Navbar.Collapse> */}
        </div>
      </Navbar>
    </Div>
  );
}
